export default class DtoFileFTP {
    constructor(obj) {
        this.url = obj.url
        this.name = obj.name
        this.size = obj.size
        this.updateDate = obj.updateDate
        this.isDirectory = obj.isDirectory
    }
}